/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

  // Store locator init
  const locatorMap = document.querySelectorAll('.ph-map, .ph-map-new');
  if(locatorMap.length>0){
      pharmacies.init();
  }
  if(typeof myAccount != 'undefined'){
    myAccount.init();
  }

})();
function recursiveAddTocart(variation_ids){
    let pox = [];
    for (let index = 0; index < variation_ids.length; ++index) {
        var element = variation_ids[index];
        pox.push({quantity: 1, id:element});
    }
    addToCartItem(pox);
    //variation_ids.forEach(element => setTimeout(addToCartItem(element), 1000));
}

function addToCartItem(element){
    fetch('/cart/add.js', {
        method: "POST",
        body:JSON.stringify({
            items:element
        }
        ),
        headers: {
            'Content-type': 'application/json; charset=UTF-8'
        }
    }).then(async res => {
        const cart = await getCart();
        var x = document.querySelectorAll(".header__cart__status");
        for (i = 0; i < x.length; i++) {
            x[i].innerHTML = cart.item_count;
            x[i].setAttribute("data-cart-count", cart.item_count);
        }
        window.cart.openCartDropdown();
        setTimeout(() => {
            window.cart.closeCartDropdown();
        }, 3000);

    });
}

function goToPos(ref,offset){

    var defaultOffset = $('.header__content').outerHeight(true);

    if(typeof offset === 'undefined') offset = defaultOffset;
    $ref = (typeof ref === 'string') ? $(ref) : ref ;

    if($ref.length == 0) return false;

    var myPos = $ref.offset().top-offset;

    function getDuration(target) {
        var minDuration = 300;
        var currentTop = $(window).scrollTop(),
        rate = 0.8,
        distance = Math.abs(currentTop - target);
        ret = distance * rate;
        return (ret > minDuration) ? ret : minDuration ;
    }


    $('html,body').animate(
        {scrollTop: myPos},
        { duration: getDuration(myPos) }
    );


    $(document).ajaxComplete(function() {
        $(window).resize();
    });
}

theme.modal = function (modalID, onInit, onClose) {
    var $thisModal = $('#' + modalID);

    if (modalID.indexOf('prev') > -1) {
        modalID = modalID.replace('--prev', '');
        $thisModal = $('#' + modalID).prevAll('.quicklook:first');

        // If first show last
        if (!$thisModal.length) {
            $thisModal = $('#' + modalID).nextAll('.quicklook:last');
        }
    } else if (modalID.indexOf('next') > -1) {
        modalID = modalID.replace('--next', '');
        $thisModal = $('#' + modalID).nextAll('.quicklook:first');

        // If last show first
        if (!$thisModal.length) {
            $thisModal = $('#' + modalID).prevAll('.quicklook:last');
        }
    }

    if (typeof (onInit) == 'function') {
        $thisModal.fadeIn('fast', onInit);
    } else {
        $thisModal.fadeIn('fast');
    }
    $thisModal.unbind('click').on('click', function (e) {
        var $target = $(e.target);
        if ($target.hasClass('close') || $target.hasClass('modal__wrapper')) {
            if (typeof (onClose) == 'function') {
                $thisModal.stop(true).fadeOut('fast', onClose);
            } else {
                $thisModal.stop(true).fadeOut('fast');
            }
        }
    });
};


/*
Callbacks
 */
async function getCart() { const result = await fetch("/cart.json"); if (result.status === 200) { return result.json(); } throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`); } // Example const cart = await getCart();
